import { HttpHeaders } from "@angular/common/http";

export class CommonUtils {
  public static appendAuthorizationHeader(httpHeaders: HttpHeaders): HttpHeaders {
    return httpHeaders.append("IsValidate", "true");
  }
}
